<div class="modal-header">
  <h4 class="modal-title">How to Setup MFA Device</h4>
  <button (click)="activeModal.close('')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-1 text-right">
      1.
    </div>
    <div class="col-11">
      Install application such as Google Authenticator, Duo Mobile, or Authy app on your mobile device or computer.
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-1 text-right">
      2.
    </div>
    <div class="col-11">
      Open your authenticator app and scan the QR code.<br/>
      <img src="{{qrCode}}" alt="code"/>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-1 text-right">
      3.
    </div>
    <div class="col-5">
      Enter the code below.<br/>
      <ngb-alert type="danger" class="mb-2" *ngIf="errorMessage" (close)="errorMessage=null">
        <p class="mb-0">{{errorMessage}}</p>
      </ngb-alert>
      <input type="text" class="form-control mb-2" name="code"
             [(ngModel)]="code"
             placeholder="Secure Code"
             autocomplete="off"
             maxlength="30">
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-1 text-right">
      4.
    </div>
    <div class="col-11">
      <button type="button" class="btn btn-dark wd-184px me-auto" (click)="register()" [disabled]="code?.length<6">Register</button>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.close('')">
    Cancel
  </button>
</div>
